import { Res, type ResourceDef } from './types';

export const RESOURCES: ResourceDef[] = [
  { key: 'oak', name: 'Oak Tree', res: Res.Wood, amount: 100, radius: 0.35, model: 'tree', blocking: true, walkable: true },
  { key: 'pine', name: 'Pine Tree', res: Res.Wood, amount: 100, radius: 0.3, model: 'pine', blocking: true, walkable: true },
  { key: 'palm', name: 'Palm Tree', res: Res.Wood, amount: 80, radius: 0.3, model: 'palm', blocking: true, walkable: true },
  { key: 'berries', name: 'Berry Bush', res: Res.Food, amount: 125, radius: 0.4, model: 'berry', blocking: true },
  { key: 'sheep', name: 'Livestock', res: Res.Food, amount: 100, radius: 0.3, model: 'sheep', blocking: false },
  { key: 'deer', name: 'Deer', res: Res.Food, amount: 100, radius: 0.3, model: 'deer', blocking: false },
  { key: 'fish', name: 'Fish', res: Res.Food, amount: 225, radius: 0.4, model: 'fish', blocking: false },
  { key: 'goldMine', name: 'Gold Mine', res: Res.Gold, amount: 800, radius: 0.45, model: 'gold', blocking: true },
  { key: 'stoneMine', name: 'Stone Mine', res: Res.Stone, amount: 350, radius: 0.45, model: 'stone', blocking: true },
];
